import { Button, Typography } from 'antd'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'

export const GoodsTemplateDownloadButton = () => {
  const mode = useCrudFormStore(state => state.mode)
  return mode === FormMode.READ ? null : (
    <Typography.Link href='/templates/比价物资导入模板.xls'>
      <Button type='link'>下载模板</Button>
    </Typography.Link>
  )
}
